<template>
    <div id="msgRecall">
        <screen ref='screen'></screen>
    </div>
</template>

<script>

import Screen from 'views/cdu/cduHeader/Screen'
import {initMsgRecall} from 'utils/initPageData'

export default { 
    name: 'MsgRecall',
    components: {
        Screen
    },
    data() {
        return {
            showData: [],
            index: [],
            page1: [
                [
                    ['MESSAGE RECALL',['showIndex','','']],
                    [1,1]
                ], 
                [
                    [ '', '' ], 
                    [ '', '' ] 
                ], 
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
                [ 
                    [ '', '' ], 
                    [ '', '' ] 
                ],
            ]
        }
    },
    methods: {
        initPage(){
            this.index = this.page1[0][1]
            this.showData = this['page'+ this.index[0]]
        }
    },
    created() {
        this.initPage()
        initMsgRecall(this)
    }
}
</script>

<style scoped>

</style>